import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { selectDineInPasscode, isDineInOrderingFlow, selectRequirePasscodeForTabOrder } from 'selectors/root';
import globalMessages from 'components/globalMessages';

import { OuterContainer, Container } from './styles';

type Props = {
  passcode?: string;
  isDineInOrderingFlow?: boolean;
  requirePasscodeForTabOrder?: boolean;
};

const ActivePasscode = ({ passcode, isDineInOrderingFlow, requirePasscodeForTabOrder }: Props) => {
  if (!isDineInOrderingFlow || !passcode || !requirePasscodeForTabOrder) return null;

  return (
    <OuterContainer>
      <Container>
        <strong>
          <FormattedMessage {...globalMessages.yourPasscode} />: #{passcode}
        </strong>
      </Container>
    </OuterContainer>
  );
};

export default connect(state => ({
  passcode: selectDineInPasscode(state),
  isDineInOrderingFlow: isDineInOrderingFlow(state),
  requirePasscodeForTabOrder: selectRequirePasscodeForTabOrder(state),
}))(ActivePasscode);
